module.exports = __webpack_public_path__ + "assets/img/btn-detail-eef788c0.png";